import { FormattedEvent } from '@eventbrite/consumer-search.event-renderer';

/**
 * Event interaction types that can be tracked
 */
export enum EventInteractions {
  Impression = 'impression',
  Click = 'click',
  Hover = 'hover',
  HideAd = 'hide-ad',
  ReportAd = 'report-ad',
  Mounted = 'mounted',
  Follow = 'follow',
  Unfollow = 'unfollow',
}

/**
 * Event name for the custom event that gets dispatched
 */
export const PLACE_EVENT_INTERACTION = 'PlaceEventInteraction';

/**
 * Raw event interaction from EventCardTracking
 */
export interface EventInteraction {
  id: string;
  action: EventInteractions;
  event: FormattedEvent;
}

/**
 * Event interaction with tracking context added
 */
export interface EventInteractionWithContext extends EventInteraction {
  user: {
    id?: string;
    locale?: string;
    guestId?: string;
    sessionId?: string;
  };
  adId?: string;
  place: {
    name: string;
    position: number;
    page: number;
    context: Record<string, unknown>;
    tabKey?: string;
    placementId?: string;
    absoluteRank?: number;
    subInterface?: {
      name?: string;
      position?: string;
    };
  };
  displayContext?: {
    hasOpenPromotion: boolean;
    hasBOGOLabel: boolean;
    urgencySignals?: string[];
  };
  venueId?: string;
}

/**
 * Custom event type for event interactions
 */
export type InteractionCustomEvent = CustomEvent<EventInteraction>;

/**
 * Element that can listen to events (simplified from HTMLElement)
 */
export interface TrackableElement {
  addEventListener(type: string, listener: (event: CustomEvent) => void): void;
  removeEventListener(type: string, listener: (event: CustomEvent) => void): void;
  dispatchEvent(event: CustomEvent): void;
}
